<template>
  <div class="baiduQueue">
    <!-- <div  class="title">
      <div class="t1">实时概况</div>
      <div class="t2">
        <div class="color1">
          <div  class="t21">{{oid==1?'用户总数':'订单总数'}}</div>
          <div  class="t22">
            <div  class="t221">{{ oid==1 ? (item.total||0) : (item.order||0) }}</div>
            <div  class="t222">{{oid==1?'人':'单'}}</div>
          </div>
        </div>
        <div class="color2">
          <div  class="t21">商品总数</div>
          <div  class="t22">
            <div  class="t221">{{ item.ware ? item.ware : 0 }}</div>
            <div  class="t222">个</div>
          </div>
        </div>
        <div class="color3">
          <div  class="t21">骑手总数</div>
          <div  class="t22">
            <div  class="t221">{{ item.rider ? item.rider : 0 }}</div>
            <div  class="t222">人</div>
          </div>
        </div>
        <div class="color4">
          <div  class="t21">收入金额</div>
          <div  class="t22">
            <div  class="t221">{{ item.money ? item.money : 0 }}</div>
            <div  class="t222">元</div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div class="content">
      <div class="c1">数据趋势</div>
      <div class="c2">
        <div class="btn" :class="cycle==1?'btn2':''" @click="updateCycle(1)">本周</div>
        <div class="btn" :class="cycle==2?'btn2':''" @click="updateCycle(2)">本月</div>
        <div class="btn" :class="cycle==3?'btn2':''" @click="updateCycle(3)">本年</div>
        <div class="btn" :class="cycle==5?'btn2':''" @click="updateCycle(5)">指定月份</div>
        <div class="btn" :class="cycle==4?'btn2':''" @click="updateCycle(4)">指定年份</div>
      </div>
      <div class="c4" v-if="cycle==5"><el-date-picker @change="getTrend" v-model="month" type="month" placeholder="选择月"> </el-date-picker></div>
      <div class="c4" v-if="cycle==4"><el-date-picker @change="getTrend" v-model="year" type="year" placeholder="选择年"> </el-date-picker></div>
      <div class="c3"><div id="myChart2" style="width:100%;height:100%"></div></div>
    </div>
    <div class="export">
      <div class="e1">数据导出</div>
      <div class="e2">
        <div class="btn" :class="export1==1?'btn2':''" @click="updateExport1(1)">最近一周</div>
        <div class="btn" :class="export1==2?'btn2':''" @click="updateExport1(2)">最近一月</div>
        <div class="btn" :class="export1==3?'btn2':''" @click="updateExport1(3)">最近三月</div>
        <div class="btn" :class="export1==4?'btn2':''" @click="updateExport1(4)">最近一年</div>
        <div class="btn" :class="export1==5?'btn2':''" @click="updateExport1(5)">自定义</div>
        
      </div>
      <div class="e3" v-if="export1==5"><el-date-picker v-model="custom" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker></div>
      <div class="e4"><el-button type="primary" @click="export2">确认导出</el-button></div>
    </div> -->
  </div>
</template>

<script>
import Cookie from "js-cookie";

export default {
  title: "课程列表",
  data() {
    return {
      tail:1,
      cycle:1,
      oid:'',
      export1:1,
      indicators:1,
      item:{},
      dayData:{},
      trendData:{},
      day:'',
      custom:[],
      month:'',
      year:''
    };
  },
  computed: {},
  components: {},
  methods: {
    
    updateExport1(e){
      this.export1=e
    },
    export2(){
      let obj={
        method:this.export1
      }
      if(this.export1==5){
        if(!this.custom || !this.custom.length){
          this.$message.error("请选择时间范围");
          return;
        }else{
          let date1=new Date(this.custom[0])
          let date2=new Date(this.custom[1])
          obj.begin=date1.getFullYear() + "-" + (date1.getMonth() + 1) +  "-" + date1.getDate()
          obj.end=date2.getFullYear() + "-" + (date2.getMonth() + 1) +  "-" + date2.getDate()
        }
      }
      let params = {
        crud: -1,
        videoJson:JSON.stringify(obj)
      };
      this.$axios
        .post("/oper_video_record", this.$qs.stringify(params))
        .then((res) => {
          if (res.data.errCode == 0) {
            window.open(res.data.data);
          }
        });
    },
    updateCycle(e){
      this.cycle=e
      this.year=''
      this.month=''
      if(this.cycle != 4&&this.cycle != 5){
        this.getTrend()
      }
    },
    updateIndicators(e){
      this.indicators=e
    },
    updateTail(e){
      this.tail=e
      if(this.tail==1){
        this.getTail()
      }
    },
    getTrend(){
      let obj={
        method:this.cycle,
        oid:Cookie.get("id")==1?null:Cookie.get("id")
      }
      if(this.cycle==4){
        let date1=new Date(this.year)
        obj.year=date1.getFullYear()
      }else if(this.cycle==5){
        let date1=new Date(this.month)
        obj.year=date1.getFullYear()
        obj.month=date1.getMonth() + 1
        
      }
      let params = {
        crud: 2,
        statisJson:JSON.stringify(obj)
      };
      this.$axios
        .post("/oper_statis_record", this.$qs.stringify(params))
        .then((res) => {
          this.trendData=res.data.data
          this.drawLine2()
        });
    },
    // getTail(){
    //   let date
    //   if(this.tail==1){
    //     let date1=new Date()
    //     date=date1.getFullYear() + "-" + (date1.getMonth() + 1) +  "-" + date1.getDate()
    //   }else{
    //     let date1=new Date(this.day)
    //     date=date1.getFullYear() + "-" + (date1.getMonth() + 1) +  "-" + date1.getDate()
    //   }
    //   let params = {
    //     crud: 11,
    //     videoJson:JSON.stringify({
    //       oneday:date
    //     })
    //   };
    //   this.$axios
    //     .post("/oper_video_record", this.$qs.stringify(params))
    //     .then((res) => {
    //       this.dayData=res.data.data
    //       this.drawLine()
    //     });
    // },
    // drawLine(){
    //     // 基于准备好的dom，初始化echarts实例
    //     let myChart = this.$echarts.init(document.getElementById('myChart'))
    //     // 绘制图表
    //     myChart.setOption({
    //         tooltip: {
    //           show:false, 
    //         },
    //         hoverAnimation:false,
    //         avoidLabelOverlap: false,
    //         label: { //  饼图图形上的文本标签
    //             show: true,
    //               position: 'center',
    //               color: '#000',
    //               fontSize: 16,
    //               fontWeight: 'bold',
    //               formatter: '{c}%' // {b}:数据名； {c}：数据值； {d}：百分比，可以自定义显示内容，
    //           },
    //         series: [{
    //             type: 'pie',
    //             radius: ['60%', '70%'],
    //             avoidLabelOverlap: false,
    //             label: {
    //               show: false,
    //               position: 'center'
    //             },
    //             emphasis: {
    //               label: {
    //                 show: true,
    //                 fontSize: '20',
    //                 fontWeight: 'bold'
    //               }
    //             },
    //             labelLine: {
    //               show: false
    //             },
    //             data: [
    //               { value: this.dayData.totalNum==0?100:100-parseInt((this.dayData.clickNum/this.dayData.totalNum*100)), name: '' ,itemStyle:{color:'#C1C1C1' },label: { normal: { show: false}}},
    //               { value: this.dayData.totalNum==0?0:parseInt(this.dayData.clickNum/this.dayData.totalNum*100), name: '点击率',itemStyle:{color:'#5DB966'},label: { normal: { color:'#5DB966',show: true}} }
    //             ]
    //           }]
    //     });
    // },
    drawLine2(){
      let myChart = this.$echarts.init(document.getElementById('myChart2'))
      let date = []
      if(this.cycle== 3 || this.cycle== 4){
        for(let i=0;i<this.trendData.dateArr.length;i++){
          console.log(new Date(this.trendData.dateArr[i]).getMonth())
          date.push((new Date(this.trendData.dateArr[i]).getMonth()+1)+'月')
        }
      }else{
        for(let i=0;i<this.trendData.dateArr.length;i++){
          console.log(new Date(this.trendData.dateArr[i]).getDate())
          date.push(new Date(this.trendData.dateArr[i]).getDate()+'日')
        }
      }
      
      myChart.setOption({
        legend: {
          data: ['总观看数', '总点击数', '播放时长','点击率(%)']
        },
        xAxis: {
          type: 'category',
          data: date
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        yAxis: {
          type: 'value',
          max:function (value){
            console.log(value)
            return value.max+5
          }
        },
        series: [
          {
            data: this.trendData.totalArr,
            name: '商品总数',
            type: 'line'
          },
          {
            data: this.trendData.FeeArr,
            name: '收入金额',
            type: 'line'
          }
        ]
      })
    },
    getData() {
      this.oid=Cookie.get("id")
      let params = {
        oid:Cookie.get("id")==1?null:Cookie.get("id")
      };
      this.$axios
        .post("/do_oper_statis", this.$qs.stringify(params))
        .then((res) => {
          this.item=res.data.data
        });
    },
  },

  mounted() {
    this.getData(); 
    // this.getTail() 
    this.getTrend()
  },
};
</script>  
<style lang="scss" scoped>
.title {
  width: 94%;
  margin: 0 auto;
  height: 180px;
  background: #FFFFFF;
  box-shadow: 0px 2px 7px 0px rgba(132,140,145,0.5);
  .t1{
    width: calc(100% - 48px);
    margin: 0 24px;
    border-bottom: 1px solid #DCDCDC;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #252429;
    height: 54px;
    line-height: 54px;
    
  }
  .t2{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: calc(100% - 48px);
    margin: 0 24px;
    height: 125px;
    &>div{
      width: 183px;
      height: 83px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 0 17px;
      border-radius: 7px;
      .t21{
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
      }
      .t22{
        display: flex;
        align-items: center;
        justify-content: space-between;
        .t221{
          font-size: 30px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
        }
        .t222{
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
        }
      }
    }
    .color1{
      background: linear-gradient(90deg, #4D09B9 0%, #BE91EE 100%);
    }
    .color2{
      background: linear-gradient(90deg, #09B95D 0%, #99EE91 100%);
    }
    .color3{
      background: linear-gradient(90deg, #0975B9 0%, #91DAEE 100%);
    }
    .color4{
      background: linear-gradient(90deg, #FF991C 0%, #FFC371 100%);
    }

  }
  
}
.baiduQueue {
  width: 100%;
  // padding: 20px 0;
  min-height: 680px;
  background: #F0F2F7;
  .head{
    width: 94%;
    margin: 17px auto;
    background: #FFFFFF;
    box-shadow: 0px 2px 7px 0px rgba(132,140,145,0.5);
    .h1{
      width: calc(100% - 48px);
    margin: 0 24px;
    border-bottom: 1px solid #DCDCDC;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #252429;
    height: 54px;
    line-height: 54px;
    }
    .h2{
      display: flex;
      align-items: center;
      padding-left: 48px;
      margin-top: 20px;
      &>div{
        margin-right: 15px;
        
      }
    }
    .h3{
      display: flex;
      align-items: center;
      height: 300px;
      width: 100%;
      .h31{
        width: 200px;
        height: 100%;
        .h311{
          font-size: 13px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
            text-align: center;
        }
      }
      .h32{
        width: calc(100% - 200px);
        display: flex;
        align-items: center;
        &>div{
          width: 33.3%;
          &>div{
            font-size: 33px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #333333;
            text-align: center;
          }
          .h321{
            margin-bottom: 30px;
            font-size: 13px;
          }
        }
      }
    }
  }
  .content{
    width: 94%;
    margin: 0 auto;
    background: #FFFFFF;
    box-shadow: 0px 2px 7px 0px rgba(132,140,145,0.5);
    position: relative;
    .c1{
      width: calc(100% - 48px);
    margin: 0 24px;
    border-bottom: 1px solid #DCDCDC;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #252429;
    height: 54px;
    line-height: 54px;
    }
    .c2{
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      padding-left: 30px;
      margin-top: 20px;
      &>div{
        margin-right: 15px;
      }
      .c21{
        margin-right: 23px;
      }
    }
    .c3{
      border-radius: 3px;
      border: 1px solid #979797;
      width: 96%;
    margin: 0 auto;
    height: 339px;
    }
    .c4{
      position: absolute;
      left: 50%;
      transform: translate(-50%,0);
      top: 0;
    }
  }
  .export{
    height: 200px;
    width: 94%;
    margin: 0 auto;
    background: #FFFFFF;
    box-shadow: 2px 5px 7px 0px rgba(132,140,145,0.5);
    position: relative;
    .e1{
      font-size: 13px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      height: 44px;
      line-height: 44px;
      padding-left: 30px;
    }
    .e2{
      display: flex;
      align-items: center;
      padding-left: 30px;
      &>div{
        margin-right: 17px;
      }
    }
    .e3{
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%,0);
      }
      .e4{
        position: absolute;
        right: 30px;
        top: 44px;
        .el-button{
        }
      }
  }
}
.btn{
  width: 80px;
        height: 30px;
        border: 1px solid #5DB966;
        border-radius: 3px;
        text-align: center;
        line-height: 30px;
        font-size: 13px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
}
.btn2{
  background: #5DB966 !important;
        color: #FFFFFF !important;
}
</style>  


// WEBPACK FOOTER //
// src/pages/index/index.vue